import React from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { pxTransform } from "@/utils";
import { XHComponentCommonProps } from "../../types";
import "./index.scss";

export type ProgressProps = {
  percent: number;
  // showPercent?: boolean;
  doneColor?: string;
  size?: number;
  backgroundColor?: string;
  maskColor?: string;
  style?: React.CSSProperties;
  text?: React.ReactNode;
} & XHComponentCommonProps;

const Progress: React.FC<ProgressProps> = props => {
  const {
    percent = 88,
    className,
    // showPercent = false,
    doneColor = "#DDD",
    backgroundColor = "rgba(0,0,0, 0.25)",
    maskColor = "#FFF",
    size,
    style,
    text,
  } = props;
  const progresslcs = classNames("xh-progress-circle", className);

  const finalSize: React.CSSProperties = size
    ? {
        width: pxTransform(size),
        height: pxTransform(size),
      }
    : {};

  const done = percent === 100;

  const finalStyle = {
    ...finalSize,
    "--percent": `${percent / 100}turn`,
    "--doneColor": doneColor,
    "--backgroundColor": backgroundColor,
    "--maskContent": "percent",
    "--maskColor": maskColor,
    ...style,
  };

  return (
    <View className={progresslcs} style={finalStyle}>
      {text ? (
        <View className="xh-progress-circle-text">{text}</View>
      ) : done ? (
        <View className="xh-progress-circle-done"></View>
      ) : null}
    </View>
  );
};

export default Progress;
